import React, { useRef, useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import FilterSidebar from './components/FilterSidebar';
import Home from './components/Home';
import CombineSidebar from './components/CombineSidebar';
import CombineScreen from './components/CombineScreen';
import PasswordProtection from './components/PasswordProtection';
import { FiFilter, FiMenu, FiGitMerge } from 'react-icons/fi'; // Install with: npm install react-icons

function App() {
  const homeRef = useRef();
  const [activeTab, setActiveTab] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isCombineSidebarOpen, setIsCombineSidebarOpen] = useState(true);
  const [consecutiveTrips, setConsecutiveTrips] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(process.env.NODE_ENV === 'development');

  const handleApplyFilters = (filters) => {
    homeRef.current?.handleApplyFilters(filters);
    // Close filter panel on mobile after applying
    if (window.innerWidth <= 768) {
      setIsFilterOpen(false);
    }
  };

  const renderMainContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home ref={homeRef} />;
      case 'combine':
        return (
          <>
            <CombineScreen consecutiveTrips={consecutiveTrips} />
            <CombineSidebar 
              isOpen={isCombineSidebarOpen} 
              onClose={() => setIsCombineSidebarOpen(false)} 
              onTripsFound={setConsecutiveTrips}
            />
          </>
        );
      default:
        return <Home ref={homeRef} />;
    }
  };

  if (process.env.NODE_ENV === 'production' && !isAuthenticated) {
    return <PasswordProtection onCorrectPassword={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className="app">
      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-button"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <FiMenu />
      </button>

      {/* Mobile Filter Button - Only show on home tab */}
      {activeTab === 'home' && (
        <button 
          className="mobile-filter-button"
          onClick={() => setIsFilterOpen(!isFilterOpen)}
        >
          <FiFilter />
        </button>
      )}

      {/* Mobile Combine Button - Only show on combine tab when sidebar is closed */}
      {activeTab === 'combine' && !isCombineSidebarOpen && (
        <button 
          className="mobile-filter-button"
          onClick={() => setIsCombineSidebarOpen(true)}
        >
          <FiGitMerge />
        </button>
      )}

      <Sidebar 
        activeTab={activeTab} 
        onTabChange={setActiveTab}
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
      
      <main className={`main-content ${activeTab === 'combine' ? 'combine-mode' : ''}`}>
        {renderMainContent()}
      </main>

      {/* Only render FilterSidebar on home tab */}
      {activeTab === 'home' && (
        <FilterSidebar 
          onApplyFilters={handleApplyFilters}
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
        />
      )}
    </div>
  );
}

export default App;
